/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationVersion } from './ApplicationVersion';
import {
    ApplicationVersionFromJSON,
    ApplicationVersionFromJSONTyped,
    ApplicationVersionToJSON,
} from './ApplicationVersion';

/**
 * 
 * @export
 * @interface ApplicationGroup
 */
export interface ApplicationGroup {
    /**
     * 
     * @type {number}
     * @memberof ApplicationGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationGroup
     */
    candidateId?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationGroup
     */
    jobId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationGroup
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationGroup
     */
    advertisementText?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationGroup
     */
    additionalInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationGroup
     */
    tone?: string;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationGroup
     */
    latestEdit?: Date;
    /**
     * 
     * @type {Array<ApplicationVersion>}
     * @memberof ApplicationGroup
     */
    versions?: Array<ApplicationVersion>;
}

/**
 * Check if a given object implements the ApplicationGroup interface.
 */
export function instanceOfApplicationGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationGroupFromJSON(json: any): ApplicationGroup {
    return ApplicationGroupFromJSONTyped(json, false);
}

export function ApplicationGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'candidateId': !exists(json, 'CandidateId') ? undefined : json['CandidateId'],
        'jobId': !exists(json, 'JobId') ? undefined : json['JobId'],
        'position': !exists(json, 'Position') ? undefined : json['Position'],
        'advertisementText': !exists(json, 'AdvertisementText') ? undefined : json['AdvertisementText'],
        'additionalInfo': !exists(json, 'AdditionalInfo') ? undefined : json['AdditionalInfo'],
        'tone': !exists(json, 'Tone') ? undefined : json['Tone'],
        'latestEdit': !exists(json, 'LatestEdit') ? undefined : (new Date(json['LatestEdit'])),
        'versions': !exists(json, 'Versions') ? undefined : ((json['Versions'] as Array<any>).map(ApplicationVersionFromJSON)),
    };
}

export function ApplicationGroupToJSON(value?: ApplicationGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'CandidateId': value.candidateId,
        'JobId': value.jobId,
        'Position': value.position,
        'AdvertisementText': value.advertisementText,
        'AdditionalInfo': value.additionalInfo,
        'Tone': value.tone,
        'LatestEdit': value.latestEdit === undefined ? undefined : (value.latestEdit.toISOString()),
        'Versions': value.versions === undefined ? undefined : ((value.versions as Array<any>).map(ApplicationVersionToJSON)),
    };
}

